/**
 *  ALT Labels
 */

export const ALT_LOGO_AFINANDO = "Logo afinando o cérebro";
export const ALT_LOGO_AFINANDO_PASCOA = "Logo do afinandinho com orelhinhas de coelho da páscoa";
export const ALT_LOGO_AFINANDO_JUNINO = "Mascote Afinandinho com chapéu de palha celebrando a Festa Junina ao lado da frase afinando o cérebro";
export const ALT_LOGO_AFINANDO_NATAL = "Mascote Afinandinho com gorro de Papai Noel celebrando o Natal ao lado da frase afinando o cérebro";


